/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import { useSelector } from "react-redux";

enum FilterTypes {
  ENHANCE_SPEECH = "STUDIO_SOUND", // need the old name for existing projects
}

export interface Filter {
  enabled: boolean;
  strengthPercent?: number;
  backgroundStrengthPercent?: number;
}

export type FilterSet = Partial<Record<FilterTypes, Filter>>;

export default FilterTypes;

export const selectEnhanceSpeechFilter = (
  filters: FilterSet | undefined
): {
  enabled: boolean;
  strengthPercent: number;
  backgroundStrengthPercent: number;
} => {
  const ENHANCE_STRENGTH_PERCENT_DEFAULT = 90;
  const BACKGROUND_PERCENT_DEFAULT = 10;

  const studioSoundEnabled = !!filters?.[FilterTypes.ENHANCE_SPEECH]?.enabled;
  const enhanceStrengthPercent =
    filters?.[FilterTypes.ENHANCE_SPEECH]?.strengthPercent ??
    ENHANCE_STRENGTH_PERCENT_DEFAULT;

  const backgroundStrengthPercent =
    filters?.[FilterTypes.ENHANCE_SPEECH]?.backgroundStrengthPercent ??
    BACKGROUND_PERCENT_DEFAULT;

  return {
    enabled: studioSoundEnabled,
    strengthPercent: enhanceStrengthPercent,
    backgroundStrengthPercent,
  };
};
